var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow04Down(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44916 44.9745C24.0572 25.9659 51.8814 31.1587 74.004 45.1307C74.3844 45.37 74.8887 45.257 75.128 44.8766C75.3672 44.4962 75.2543 43.992 74.8739 43.7527C52.1325 29.3881 23.5289 24.2364 2.34383 43.7778C2.01318 44.0816 1.99279 44.5969 2.29816 44.9288C2.60193 45.2595 3.11721 45.2798 3.44916 44.9745Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0242 44.1788C72.5942 44.1084 70.8006 44.0001 70.5967 43.9937C65.0711 43.8215 59.815 44.5158 54.4784 46.0022C54.0451 46.1223 53.7913 46.573 53.9114 47.0062C54.0315 47.4395 54.4822 47.6933 54.9155 47.5732C60.09 46.1302 65.1873 45.4555 70.5472 45.6232C70.8596 45.6328 74.8914 45.8787 75.7104 45.8671C76.0464 45.864 76.2355 45.7578 76.2777 45.7285C76.5079 45.5815 76.596 45.391 76.6349 45.2319C76.6774 45.052 76.6751 44.7379 76.4523 44.3988C76.2178 44.0448 75.554 43.4332 75.3989 43.2653C73.0661 40.7253 70.2412 38.0937 68.1274 35.1331C66.1113 32.3098 64.7403 29.1834 65.2046 25.519C65.2615 25.073 64.9437 24.6648 64.4977 24.6079C64.0516 24.551 63.6435 24.8687 63.5865 25.3148C63.0683 29.4117 64.5472 32.9246 66.7999 36.0797C68.9017 39.0226 71.6839 41.6513 74.0242 44.1788Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(46.1913 83) rotate(-141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow04Down);
export default __webpack_public_path__ + "static/media/Arrow_04-down.31a2660642f587a1e2eb69e32a0f2a6d.svg";
export { ForwardRef as ReactComponent };